import { render } from "./BaseMenu.vue?vue&type=template&id=4bb14158&scoped=true&ts=true"
import script from "./BaseMenu.vue?vue&type=script&lang=ts"
export * from "./BaseMenu.vue?vue&type=script&lang=ts"

import "./BaseMenu.vue?vue&type=style&index=0&id=4bb14158&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bb14158"]])

export default __exports__